import * as TrainingIntensitySaga from './saga';
import * as TrainingIntensitySelectors from './selectors';
import * as TrainingIntensityReducer from './slice';
import TrainingIntensityPage from './TrainingIntensityPage';

const TrainingIntensityActions = TrainingIntensityReducer.TrainingIntensityActions;
export {
  TrainingIntensityActions,
  TrainingIntensityPage,
  TrainingIntensityReducer,
  TrainingIntensitySaga,
  TrainingIntensitySelectors,
};
